import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import PersonFieldLabel from '../PersonFieldLabel';

function PhoneNumberField() {
  return (
    <div className="my-4 w-full">
      <div className="block ml-6">
        <div className="w-full">
          <PersonFieldLabel htmlFor="phone-number-input">
            Phone Number
          </PersonFieldLabel>
        </div>
        <div className="w-full">
          <FormikInput id="phone-number-input" name="phoneNumber" />
        </div>
      </div>
    </div>
  );
}

export default PhoneNumberField;
